import ContentTypeSelect from './content_type_select.vue'

// eslint-disable-next-line import/prefer-default-export
export const UiFormContentTypeSelect = ContentTypeSelect
